import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { Container, Section, SectionHead } from "src/components/common"
import { social } from "src/data/config"
import { Grid, Text, Facts, StackTitle, Stack } from "./styles"

const LABELS = {
  ReactJS: "React",
  Wordpress: "WordPress",
  Typescript: "TypeScript",
}

export const About = () => {
  const { t } = useTranslation()
  const facts = t("about:facts", { returnObjects: true })
  const groups = t("about:stack_groups", { returnObjects: true })

  return (
    <Section id="about" aria-labelledby="about-title">
      <Container>
        <Grid>
          <div>
            <SectionHead id="about-title" title={t("about:headline")} />
            <Text dangerouslySetInnerHTML={{ __html: t("about:text") }} />
            <a href={social.linkedin} target="_blank" rel="noopener noreferrer">
              {t("about:linkedin")}{" "}
              <span className="sr-only">({t("external_link")})</span>
            </a>
          </div>
          <div>
            <Facts>
              {facts.map((fact, index) => (
                <li key={index}>{fact}</li>
              ))}
            </Facts>
            <StackTitle>{t("about:stack_headline")}</StackTitle>
            <Stack>
              {groups.map(group => (
                <div key={group.title}>
                  <dt>{group.title}</dt>
                  <dd>
                    {group.items.map(name => LABELS[name] || name).join(", ")}
                  </dd>
                </div>
              ))}
            </Stack>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}
